module.exports = __webpack_public_path__ + "img/24.1133df3e.png";